import React, { useState } from 'react';
import { Box, Button, Menu, MenuItem } from '@material-ui/core';
import { useEntity } from '@backstage/plugin-catalog-react';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import VSCodeIcon from '../../assets/logos/vscode.svg';

export const VSCodeCloneButton = () => {
  const { entity } = useEntity();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  
  const repoAnnotation =
    entity.metadata.annotations?.['backstage.io/source-location'] ||
    entity.metadata.annotations?.['github.com/project-slug'];

  if (!repoAnnotation) return null;

  let repoUrlHttps = repoAnnotation.replace(/^url:/, '');
  if (repoAnnotation.startsWith('github.com/')) {
    repoUrlHttps = `https://${repoAnnotation}`;
  }

  if (!repoUrlHttps.endsWith('.git')) {
    const urlObj = new URL(repoUrlHttps.startsWith('http') ? repoUrlHttps : `https://${repoUrlHttps}`);
    const parts = urlObj.pathname.split('/').filter(Boolean);
    if (parts.length >= 2) {
       repoUrlHttps = `${urlObj.origin}/${parts[0]}/${parts[1]}.git`;
    }
  }

  const urlObj = new URL(repoUrlHttps);
  const host = urlObj.hostname;
  const path = urlObj.pathname.substring(1); 
  const repoUrlSsh = `git@${host}:${path}`;
  
  const vscodeUrlHttps = `vscode://vscode.git/clone?url=${encodeURIComponent(repoUrlHttps)}`;
  const vscodeUrlSsh = `vscode://vscode.git/clone?url=${encodeURIComponent(repoUrlSsh)}`;

  const handleOpenMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  return (
    <Box display="flex" alignItems="center" style={{ marginRight: '16px' }}>
      <Button
        variant="contained"
        size="small"
        onClick={handleOpenMenu}
        style={{ 
          textTransform: 'none', 
          backgroundColor: '#e4e4e4', 
          color: '#333',
          boxShadow: 'none',
          border: '1px solid #ccc',
          padding: '4px 12px'
        }}
        startIcon={
          <img
            src={VSCodeIcon}
            alt="VS Code"
            width={16}
            height={16}
          />
        }
        endIcon={<ArrowDropDownIcon />}
      >
        Open in
      </Button>
      <Menu
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleCloseMenu}
        getContentAnchorEl={null}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        MenuListProps={{
          style: {
            padding: '0',
            borderRadius: '4px',
          },
        }}
      >
        <MenuItem component="a" href={vscodeUrlHttps} onClick={handleCloseMenu} style={{ fontSize: '14px', color: '#333' }}>
          VS Code Desktop (using HTTPS)
        </MenuItem>
        <MenuItem component="a" href={vscodeUrlSsh} onClick={handleCloseMenu} style={{ fontSize: '14px', color: '#333' }}>
          VS Code Desktop (using SSH)
        </MenuItem>        
      </Menu>
    </Box>
  );
};
